import { EnumValues } from '@/services/types/EnumValues';

export const AccountTypeEnum = {
  BUSINESS: 'business',
  PERSONAL: 'personal'
} as const;

export type AccountType = EnumValues<typeof AccountTypeEnum>;
